module.exports = __webpack_public_path__ + "img/m20.1e6ef4f.jpg";